var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.item)?_c('div',{staticClass:"two-images"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"two-images__wrapper"},_vm._l((_vm.item.images),function(el){return _c('div',{staticClass:"two-images__wrapper_img"},[_c('img',{attrs:{"src":el.value,"alt":el.title}})])}),0)])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }